<template>
	<v-text-field
		:id="id"
		ref="priceInput"
		:label="label"
		:loading="loading"
		:disabled="disabled"
		:hide-details="hideDetails"
		outlined
		:rules="rules"
		class="mt-3 pt-0"
		v-model="priceinput"
		prefix="$"
		type="number"
		maxlength="13"
		step="0.01"
		min="0"
		size="13"
		:append-outer-icon="appendOuterIcon"
		:placeholder="placeholder"
		v-on:click:append-outer="$emit('click:append-outer', true)"
		v-on:onchange="$emit('onchange', true)"
		v-on:keypress="limitDecimal($event, priceinput)"
		v-on:keyup="$emit('keyup', true)"
	></v-text-field>
</template>
<script>
export default {
	name: "price-input",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		value: {
			type: [String, Number],
			default: null,
		},
		rules: {
			type: [Array, Object],
			default: () => {
				return [];
			},
		},
		placeholder: {
			type: String,
			default: null,
		},
		id: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: null,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		appendOuterIcon: {
			type: String,
			default: null,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			priceinput: null,
		};
	},
	watch: {
		value() {
			this.priceinput = this.value;
		},
		priceinput() {
			this.$emit("input", this.priceinput);
		},
	},
	mounted() {
		this.priceinput = this.value;
	},
};
</script>
